<template>
  <div>
    <b-container fluid class="filter-requirements-input">
      <b-row align-h="start">
        <b-col cols="3">
          <b-form-input name="query"
                        v-model="searchQuery"
                        placeholder="Filter requirements">
          </b-form-input>
        </b-col>
        <b-col cols="3">
          <b-btn v-b-toggle.collapse1 variant="primary">
            Hide/show columns
            <icon class="when-opened" name="chevron-up"></icon>
            <icon class="when-closed" name="chevron-down"></icon>
          </b-btn>
          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-form-group>
                <b-form-checkbox-group id="checkboxes1" name="flavour1" v-model="selectedIssueTypeColumns" :options="issueTypeColumnOptions">
                </b-form-checkbox-group>
              </b-form-group>
            </b-card>
          </b-collapse>
        </b-col>
        <b-col cols="3">
          <b-dropdown id="dropdown-1">
            <template slot="button-content">
              <icon :name="loading ? 'spinner' : 'download'"
                    :pulse="loading"
                    style="vertical-align: middle;"/> Export
            </template>
            <b-dropdown-item @click="generateDocx()">Word (.docx)</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col cols="3">
          <div v-show="loading">
            <h7>Generating your export...</h7>
            <b-progress :value=progressValue variant="success" animated class="mt-2"></b-progress>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <traceability-matrix-grid :searchQuery="searchQuery"
                              :selectedIssueTypeColumns="selectedIssueTypeColumns"></traceability-matrix-grid>
  </div>
</template>

<script>
  import TraceabilityMatrixGrid from './TraceabilityMatrixGrid'
  export default {
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      currentProjectIsGlobal () {
        return this.currentProject && this.currentProject.id === 0
      }
    },
    watch: {
      currentProject (currentValue) {
        if (this.currentProject) {
          this.clearData()
          // For global requirements project, we need to get all issue types. Otherwise we just get them for the current project
          if (this.currentProjectIsGlobal) {
            this.getAllIssueTypes()
          } else {
            this.getIssueTypes()
          }
        }
      },
      selectedIssueTypeColumns (newValue) {
        // Convert from a list of objects to a comma separated string of IDs e.g. "1,2,3"
        let theJson = JSON.parse(localStorage.getItem('selectedIssueTypes'))
        if (!theJson) {
          theJson = {}
        }
        theJson[this.currentProject.id] = newValue.map(a => a.id)
        localStorage.setItem('selectedIssueTypes', JSON.stringify(theJson))
      }
    },
    mounted () {
      // For global requirements project, we need to get all issue types. Otherwise we just get them for the current project
      if (this.currentProjectIsGlobal) {
        this.getAllIssueTypes()
      } else {
        this.getIssueTypes()
      }
    },
    components: {TraceabilityMatrixGrid},
    data () {
      return {
        issueTypeColumnOptions: [],
        jobId: null,
        loading: false,
        presignedUrl: null,
        progressValue: 0,
        selectedIssueTypeColumns: [],
        searchQuery: ''
      }
    },
    methods: {
      clearData () {
        this.issueTypeColumnOptions = []
        this.jobId = null
        this.presignedUrl = null
        this.progressValue = 0
      },
      downloadDocx () {
        let link = document.createElement('a')
        document.body.appendChild(link)
        link.download = 'test.png'
        link.href = this.presignedUrl
        link.click()
        this.loading = false
      },
      getIssueTypes () {
        window.AP.request({
          url: `/rest/api/3/project/${this.currentProject.id}`,
          success: response => {
            // convert the string response to JSON
            response = JSON.parse(response)
            const issueTypesSorted = response.issueTypes.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
            this.issueTypeColumnOptions = issueTypesSorted.map(i => {
              return {'text': i.name, 'value': i}
            })
            this.setSelectedIssueTypes(issueTypesSorted)
          },
          error: () => {
            console.log(arguments)
          }
        })
      },
      getAllIssueTypes () {
        window.AP.request({
          url: '/rest/api/3/issuetype',
          success: response => {
            // convert the string response to JSON
            response = JSON.parse(response)
            const issueTypesSorted = response.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
            this.issueTypeColumnOptions = issueTypesSorted.map(i => {
              return {'text': i.name, 'value': i}
            })
            this.setSelectedIssueTypes(issueTypesSorted)
          },
          error: () => {
            console.log(arguments)
          }
        })
      },
      generateDocx () {
        this.loading = true
        this.getExport('docx')
      },
      getExport (format) {
        this.$http.post(
          '/api/requirement/matrix/export',
          {
            atlassian_project_id: this.currentProject.id,
            type: format,
            selected_issue_types: this.selectedIssueTypeColumns
          }
        ).then(response => {
          if (format === 'docx') {
            this.presignedUrl = response.data.presigned_url
            this.jobId = response.data.job_id
            this.updateProgress()
          }
        }, response => {
          this.loading = false
          window.AP.flag.create({
            title: 'Error',
            body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
            type: 'error',
            close: 'auto'
          })
        }
        )
      },
      setSelectedIssueTypes (allIssueTypes) {
        if (localStorage.getItem('selectedIssueTypes')) {
          const typeIDJSON = JSON.parse(localStorage.getItem('selectedIssueTypes'))
          if (this.currentProject.id in typeIDJSON) {
            this.selectedIssueTypeColumns = allIssueTypes.filter(s => typeIDJSON[this.currentProject.id].includes(s.id))
          } else {
            this.selectedIssueTypeColumns = allIssueTypes
          }
        } else {
          this.selectedIssueTypeColumns = allIssueTypes
        }
      },
      updateProgress () {
        this.$http.get(
          `/api/job/status/${this.jobId}`
        ).then(response => {
          if (response.data.status !== 'queued' && response.data.status !== 'started') {
            this.loading = false
            this.progressValue = 0
            if (response.data.status === 'finished') {
              this.downloadDocx()
            } else {
              window.AP.flag.create({
                title: 'Error',
                body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
                type: 'error',
                close: 'auto'
              })
            }
          } else {
            this.progressValue = response.data.completed_rows * 100 / response.data.total_rows
            setTimeout(() => {
              this.updateProgress()
            }, 2000)
          }
        }, response => {
          console.log('error')
          this.loading = false
          this.progressValue = 0
          window.AP.flag.create({
            title: 'Error',
            body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
            type: 'error',
            close: 'auto'
          })
        })
      }
    }
  }

</script>

<style>
  .filter-requirements-input {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// TraceabilityMatrixView.vue?4f76b6d4